module.exports = __webpack_public_path__ + "static/media/bg.a53de426.jpg";